import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const TermsAndConditions = () => {
  return (
    <LegalPageLayout title="Terms and conditions">
      <div className="space-y-8 font-tamil-body leading-relaxed">
        <section>
          <div className="flex items-center gap-3 mb-4">
            <h2 className="text-2xl font-bold text-amber-400">விதிமுறைகள் மற்றும் நிபந்தனைகள்</h2>
          </div>
          <p className="text-lg font-semibold text-amber-100 mb-4 italic">By using our website and services, you agree to the following:</p>
        </section>

        <section className="bg-white/5 p-6 rounded-2xl border border-white/5">
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Nature of Service</h3>
          <p>Arulvaaku/Astrology is a matter of faith. The guidance provided is based on traditional beliefs and individual interpretations.</p>
        </section>

        <section className="bg-white/5 p-6 rounded-2xl border border-white/5">
          <h3 className="text-xl font-semibold text-amber-300 mb-3">No Guarantee</h3>
          <p>While we strive for accuracy, results may vary from person to person. We do not guarantee 100% outcomes for any life problems.</p>
        </section>

        <section className="bg-white/5 p-6 rounded-2xl border border-white/5">
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Consultation Fee</h3>
          <p>The fee (₹300) is for the time and expertise of the consultant and is non-refundable once the consultation is completed.</p>
        </section>

        <section className="bg-white/5 p-6 rounded-2xl border border-white/5">
          <h3 className="text-xl font-semibold text-amber-300 mb-3">Age Limit</h3>
          <p>Our services are intended for individuals above 18 years of age.</p>
        </section>
      </div>
    </LegalPageLayout>
  );
};

export default TermsAndConditions;
